import { render, staticRenderFns } from "./PaginationNav.vue?vue&type=template&id=d2ad5948"
import script from "./PaginationNav.vue?vue&type=script&lang=js"
export * from "./PaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports